import * as React from 'react'
require('../base.module.scss')
import { BaseComponentProps } from '../Common/extractClassNamesFromProps'
import { extractClassNamesFromProps } from '../Common/extractClassNamesFromProps'

import * as st from './Logo.module.scss'
import { Logo as LogoOptions } from '../Common/constants'

interface LogoProps extends BaseComponentProps {
    use: LogoOptions
}

export const Logo: React.ComponentType<LogoProps> = (props) => {
    const className = extractClassNamesFromProps(props, {
        [st.brand]: props.use === LogoOptions.brand,
        [st.amazon]: props.use === LogoOptions.amazon,
        [st.prime]: props.use === LogoOptions.prime,
        [st.isPrime]: props.use === LogoOptions.isPrime,
        [st.primeSash]: props.use === LogoOptions.primeSash,
        [st.imdb]: props.use === LogoOptions.imdb,
        [st.apple]: props.use === LogoOptions.apple,
        [st.playStore]: props.use === LogoOptions.playStore,
    })
    return <div className={className}>{props.children}</div>
}

// Add displayName to preserve the component name on snapshot testing
Logo.displayName = 'Logo'
